// PaymentSuccess.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';

const PaymentSuccess = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const paymentId = query.get('payment_id');
  const navigate = useNavigate();

  useEffect(() => {
    const auth = getAuth();

    const unsubscribe = onAuthStateChanged(auth, (user) => {

      if (!user) {
        alert('User not logged in yet.');
        return;
      }

      if (!paymentId) {
        alert('No paymentId found.');
        return;
      }

      //alert(`User logged in: ${user.email}`);
      //alert(`User id: ${user.uid}`);
      //alert(`Payment ID: ${paymentId}`);

      const sendToBackend = async () => {
        try {
          const res = await fetch('https://verifypayment-ghe2awx3kq-uc.a.run.app', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ paymentId, uid: user.uid }),
          });

          const data = await res.json();
          //alert(`Server response: ${JSON.stringify(data)}`);
          //alert('User Updated');

        if (data.success) {
            //console.log(data);
            setTimeout(() => {
                navigate("/Eascode_Agent_Lesson"); // change this to whatever page you want
            }, 2000);
            }
          
          } catch (error) {
          alert(`Payment verification failed: ${error.message}`);
          console.error(error);
        }
      };

      sendToBackend();
    });

    return () => unsubscribe();
  }, [paymentId]);

  return <div>✅ Payment Verified! Please wait Your account is being updated...</div>;
};

export default PaymentSuccess;
